import React from "react";
import { Helmet } from "react-helmet";
import "../styles/subpages.css";
import "../styles/common.css";

const Impresszum = () => {
  return (
    <section id="impresszum" className="subpage-section">
      <Helmet>
        <title>Impresszum | Bikázás Pest</title>
        <meta
          name="description"
          content="A Bikázás Pest weboldal üzemeltetőjének jogi és cégadatai. Kötelező tájékoztatás az Eker. tv. 4. § alapján."
        />
        <link rel="canonical" href="https://bikazaspest.hu/impresszum" />

        {/* Open Graph */}
        <meta property="og:type" content="article" />
        <meta property="og:title" content="Impresszum | Bikázás Pest" />
        <meta
          property="og:description"
          content="Üzemeltetői és jogi információk a Bikázás Pest weboldaláról. Cégadatok és kötelező tájékoztatás."
        />
        <meta property="og:url" content="https://bikazaspest.hu/impresszum" />
        <meta property="og:image" content="/android-chrome-512x512.png" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Impresszum | Bikázás Pest" />
        <meta
          name="twitter:description"
          content="A Bikázás Pest weboldal üzemeltetőjének jogi és cégadatai."
        />
        <meta name="twitter:image" content="/android-chrome-512x512.png" />
      </Helmet>

      <div className="container text-center d-flex flex-column align-items-center">
        <header className="subpage-header pt-1 mt-1">
          <h1>Impresszum</h1>
          <div className="divider mx-auto">
            <span></span>
            <span></span>
            <span></span>
          </div>
          <p className="subpage-intro">
            Jelen impresszum a bikazaspest.hu weboldal üzemeltetőjének jogi
            adatait és az Eker. tv. 4. § szerinti kötelező tájékoztatást
            tartalmazza.
          </p>
        </header>

        <div className="subpage-card text-center">
          <h3>1. Szolgáltató adatai</h3>
          <p>
            <strong>Cégnév:</strong> Sempy & Dani Car Kft. <br />
            <strong>Székhely:</strong> 2340 Kiskunlacháza, Rákóczi út 125.{" "}
            <br />
            <strong>Adószám:</strong> 32875773-2-13
            <br />
          </p>

          <h3>2. Tárhelyszolgáltató</h3>
          <p>
            <strong>Szolgáltató:</strong> Amazon Web Services (AWS) <br />
            <strong>Székhely:</strong> Seattle, WA, USA <br />
            <strong>Weboldal:</strong>{" "}
            <a href="https://aws.amazon.com" target="_blank" rel="noreferrer">
              https://aws.amazon.com
            </a>
          </p>

          <h3>3. Felelősség kizárása</h3>
          <p>
            A weboldalon található információk tájékoztató jellegűek. A
            szolgáltató nem vállal felelősséget az esetleges hibákért,
            elírásokért vagy a tartalom naprakészségéért.
          </p>

          <h3>4. Szerzői jog</h3>
          <p>
            A weboldal teljes tartalma (szövegek, képek, logók stb.) a
            szolgáltató tulajdonát képezi. Azok másolása, felhasználása vagy
            terjesztése kizárólag írásos engedéllyel lehetséges.
          </p>

          <h3>5. Jogviták</h3>
          <p>
            A weboldal használatával kapcsolatos vitás ügyekben a felek a
            Szolnoki Járásbíróság kizárólagos illetékességét kötik ki.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Impresszum;
